"use client";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons"; //icons import
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function FaIcon({icon, className}:{icon:IconDefinition, className?:any}) {
    return <FontAwesomeIcon icon={icon} className={className} />;
}